import * as React from "react";
import { Row, Col, Pagination } from "react-bootstrap";
import "./style.scss";

class PaginationBlock extends React.Component {
  constructor(props) {
    super(props);

    this.items = [];
  }

  // Когда показывать перейти к первой странице
  showFirst() {
    if (this.props.current > 3 && this.props.pages > 10) {
      return true;
    }
  }

  // Когда показывать перейти к последней странице
  showLast() {
    if (this.props.current < this.props.pages - 3 && this.props.pages > 10) {
      return true;
    }
  }

  // Добавить страницу в список
  addPage(number, href) {
    this.items.push(
      <Pagination.Item key={number} active={number === this.props.current} href={href}>
        {number}
      </Pagination.Item>
    );
  }

  pages() {
    for (let number = 1; number <= this.props.pages; number++) {
      // Ссылка на страницу
      let href = number == 1 ? `${this.props.path}/` : `${this.props.path}/${number}/`;

      if (this.props.pages > 10) {
        // Показываем несколько страниц
        if (this.props.current <= 3 && number <= 6) {
          this.addPage(number, href);
        }
        if (this.props.current > 3 && number <= this.props.current + 2 && number >= this.props.current - 2 && this.props.current < this.props.pages - 3) {
          this.addPage(number, href);
        }
        if (this.props.current >= this.props.pages - 3 && number >= this.props.pages - 5) {
          this.addPage(number, href);
        }
      } else {
        // Показываем все страницы
        this.items.push(
          <Pagination.Item key={number} active={number === this.props.current} href={href}>
            {number}
          </Pagination.Item>
        );
      }
    }
    return this.items;
  }

  render() {
    return (
      <>
        {this.props.pages != 1 && (
          <Row className="mt-5">
            <Col className="Pagination">
              <Pagination>
                {this.showFirst() && <Pagination.First href={`${this.props.path}/`} />}

                {this.pages()}

                {this.showLast() && <Pagination.Last href={`${this.props.path}/${this.props.pages}/`} />}
              </Pagination>
            </Col>
          </Row>
        )}
      </>
    );
  }
}

export default PaginationBlock;
